/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_It_HelpsInputs */

const en_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it helps?`)
};

const ar_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف يساعد ذلك؟`)
};

const de_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hilft es?`)
};

const es_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo ayuda esto?`)
};

const fr_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment cela aide-t-il ?`)
};

const it_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come può aiutare?`)
};

const ja_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`効果`)
};

const ko_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떻게 도움이 되나요?`)
};

const pt_br_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como isso ajuda?`)
};

const ru_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как это помогает?`)
};

const th_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มันช่วยได้อย่างไร?`)
};

const tr_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl yardımcı olur?`)
};

const zh_cn_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么这么做？`)
};

const zh_tw_how_it_helps = /** @type {(inputs: How_It_HelpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為什麽這麼做？`)
};

/**
* | output |
* | --- |
* | "How it helps?" |
*
* @param {How_It_HelpsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_it_helps = /** @type {((inputs?: How_It_HelpsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_It_HelpsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_it_helps(inputs)
	if (locale === "ar") return ar_how_it_helps(inputs)
	if (locale === "de") return de_how_it_helps(inputs)
	if (locale === "es") return es_how_it_helps(inputs)
	if (locale === "fr") return fr_how_it_helps(inputs)
	if (locale === "it") return it_how_it_helps(inputs)
	if (locale === "ja") return ja_how_it_helps(inputs)
	if (locale === "ko") return ko_how_it_helps(inputs)
	if (locale === "pt_br") return pt_br_how_it_helps(inputs)
	if (locale === "ru") return ru_how_it_helps(inputs)
	if (locale === "th") return th_how_it_helps(inputs)
	if (locale === "tr") return tr_how_it_helps(inputs)
	if (locale === "zh_cn") return zh_cn_how_it_helps(inputs)
	return zh_tw_how_it_helps(inputs)
});